const getHighlightedTextParts = (searchQuery, text) => {
  const normalizedSearchQuery = searchQuery.trim().toLowerCase();

  if (!normalizedSearchQuery) {
    return [{ text, isMatch: false }];
  }

  const lowerText = text.toLowerCase();
  const parts = [];
  let startIndex = 0;

  while (startIndex < text.length) {
    const matchIndex = lowerText.indexOf(normalizedSearchQuery, startIndex);

    if (matchIndex === -1) {
      parts.push({ text: text.slice(startIndex), isMatch: false });
      break;
    }

    if (matchIndex > startIndex) {
      parts.push({ text: text.slice(startIndex, matchIndex), isMatch: false });
    }

    const matchEndIndex = matchIndex + normalizedSearchQuery.length;
    parts.push({ text: text.slice(matchIndex, matchEndIndex), isMatch: true });
    startIndex = matchEndIndex;
  }

  return parts.length ? parts : [{ text, isMatch: false }];
};

export default getHighlightedTextParts;
